import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { MarksheetDto, StudentDto, UpdateStudentDto } from '@oracychampions/api-interfaces';

@Injectable({
  providedIn: 'root',
})
export class StudentsService {
  private http = inject(HttpClient);

  refresh$ = new BehaviorSubject(null);

  reloadGroups() {
    this.refresh$.next(null);
  }

  getStudent(id: string): Observable<StudentDto> {
    return this.refresh$.pipe(switchMap(() => this.http.get<StudentDto>(`${environment.API}/students/${id}`)));
  }

  getStudents(): Observable<StudentDto[]> {
    return this.refresh$.pipe(switchMap(() => this.http.get<StudentDto[]>(`${environment.API}/students`)));
  }

  createStudent(student: UpdateStudentDto): Observable<StudentDto> {
    return this.http.post<StudentDto>(`${environment.API}/students`, student);
  }

  updateStudent(id: string, student: UpdateStudentDto): Observable<StudentDto> {
    return this.http.patch<StudentDto>(`${environment.API}/students/${id}`, student);
  }

  deleteStudent(id: string): Observable<any> {
    return this.http.delete<StudentDto[]>(`${environment.API}/students/${id}`);
  }

  getStudentMarksheets(id: string): Observable<MarksheetDto[]> {
    return this.http.get<MarksheetDto[]>(`${environment.API}/students/${id}/marksheets`);
  }
}
